import { useEffect, useState } from 'react';
import api from '@/api';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { fetchCompanySolutionList } from '@/features/company/companySlice';
import clsx from 'clsx';
import { message, Modal } from 'antd';

const ManageSolutionPage = () => {
  const dispatch = useDispatch();
  const { current: company, solutionIds } = useSelector((state: RootState) => state.company);
  const [solutionList, setSolutionList] = useState<any[]>([]);

  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    api.get('/solution').then(({ data }) => setSolutionList(data.solution));
  }, []);

  useEffect(() => {
    if (company) {
      dispatch(fetchCompanySolutionList({ companyId: company.base?.id }));
    }
  }, [company, dispatch]);

  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold">제품 정보</h1>

      {company === null && <div>회사 가입 승인 후 사용 가능합니다.</div>}
      {company &&
        solutionList.map((solution) => (
          <div className="p-5 bg-white rounded flex justify-between" key={`solution-${solution.base?.id}`}>
            <div>{solution.name}</div>
            <div>
              <div
                className={clsx(
                  'relative rounded-full w-12 h-6 transition duration-200 ease-linear',
                  solutionIds.includes(solution.base?.id) ? 'bg-green-400' : 'bg-gray-400',
                )}
              >
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-element-interactions */}
                <label
                  htmlFor="toggle"
                  className={clsx(
                    'absolute left-0 bg-white border-2 mb-2 w-6 h-6 rounded-full transition transform duration-100 ease-linear cursor-pointer',
                    solutionIds.includes(solution.base?.id) ? 'translate-x-full border-green-400' : 'translate-x-0 border-gray-400',
                  )}
                  onClick={() => {
                    if (solutionIds.includes(solution.base?.id)) {
                      modal.confirm({
                        className: 'pincarbiz',
                        title: '서비스 이용 중지',
                        content: <div>&apos;{solution.name}&apos;를 중지하시겠습니까?</div>,
                        centered: true,
                        onOk: () => {
                          console.log('aaa');
                        },
                      });
                    } else {
                      modal.confirm({
                        className: 'pincarbiz',
                        title: '서비스 이용 신청',
                        content: <div>&apos;{solution.name}&apos;를 사용하시겠습니까?</div>,
                        centered: true,
                        onOk: () => {
                          api
                            .post('/solution', 'psolution.PbSolutionChangeStatusRequest', {
                              companyId: company.base?.id,
                              solutionId: solution.base?.id,
                            })
                            .then(() => {
                              dispatch(fetchCompanySolutionList({ companyId: company.base?.id }));
                              message.success('서비스 사용 신청이 완료되었습니다.');
                            })
                            .catch(() => {
                              message.error('서비스 사용 신청이 실패했습니다.');
                            });
                        },
                      });
                    }
                  }}
                />
                <input
                  type="checkbox"
                  defaultChecked={solutionIds.includes(solution.base?.id)}
                  id="toggle"
                  name="toggle"
                  className="appearance-none w-full h-full active:outline-none focus:outline-none"
                />
              </div>
            </div>
          </div>
        ))}

      {contextHolder}
    </div>
  );
};

export default ManageSolutionPage;
